import Vue from 'vue';
import i18n from '@/i18n';

Number.prototype.toFixed = function (d) {
    var s = this + "";
    if (!d) d = 0;
    if (s.indexOf(".") == -1) s += ".";
    s += new Array(d + 1).join("0");
    if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
        s = "0" + RegExp.$2;
        var pm = RegExp.$1;
        var a = RegExp.$3.length;
        var b = true;
        if (a == d + 2) {
            a = s.match(/\d/g);
            if (parseInt(a[a.length - 1]) > 4) {
                for (var i = a.length - 2; i >= 0; i--) {
                    a[i] = parseInt(a[i]) + 1;
                    if (a[i] == 10) {
                        a[i] = 0;
                        b = i != 1;
                    } else break;
                }
            }
            s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

        } if (b) s = s.substr(1);
        return (pm + s).replace(/\.$/, "");
    } return this + "";

};

// 格式化金额（通过lessThanZero控制是否允许出现负值）
function formatWithMoney(money, lessThanZero) {
    if (!money || money == 0) return '0.00';
    if (!lessThanZero && Number(money) < 0) return '0.00';// 默认不允许小于0
    switch (i18n.locale) {
        default:
        case 'zhHans':
            return parseFloat(' ' + money).toFixed(2);
    }
}
Vue.filter('formatWithMoney', formatWithMoney);

// 格式化金额（保持兼容性）
function formatMoney(money) {
    return formatWithMoney(money, true);
}
Vue.filter('formatMoney', formatMoney);

// 格式化数字
function formatWithDot(number, fix, lessThanZero) {
    if (!number) return parseInt('0').toFixed(fix);
    if (!lessThanZero && Number(number) < 0) return parseInt('0').toFixed(fix);// 默认不允许小于0
    switch (i18n.locale) {
        default:
        case 'zhHans':
            return parseFloat(' ' + number).toFixed(fix);
    }
}
Vue.filter('formatWithDot', formatWithDot);

// 格式化数字
function formatWithDotNoMoreThan(number, fix, lessThanZero) {
    if (!number) return '0';
    if (!lessThanZero && Number(number) < 0) return '0';// 默认不允许小于0
    switch (i18n.locale) {
        default:
        case 'zhHans':
            return parseFloat(Number(number).toFixed(fix));
    }
}
Vue.filter('formatWithDotNoMoreThan', formatWithDotNoMoreThan);

// 格式化数字
function formatTwoDot(number, lessThanZero) {
    // return formatWithDot(number, 2, lessThanZero);
    return formatWithDotNoMoreThan(number, 2, lessThanZero);// 数字格式不显示'.00',暂时更换为formatWithDotNoMoreThan,后续再详细加保留小数的处理
}
Vue.filter('formatTwoDot', formatTwoDot);

// 格式化数字
function formatNoDot(number, lessThanZero) {
    return formatWithDot(number, 0, lessThanZero);
}
Vue.filter('formatNoDot', formatNoDot);

// 格式化数字
function onlyInt(number) {
    return number.replace(/[^\d]/g, '');
}
Vue.filter('onlyInt', onlyInt);

function moneyFormatWithDotNoMoreThan(number, fix, lessThanZero) {
    if (!number) return parseInt('0').toFixed(fix);
    if (!lessThanZero && Number(number) < 0) return parseInt('0').toFixed(fix);// 默认不允许小于0

    if (number.toString().split('.').length == 1 || number.toString().split('.')[1].length < 3) return parseFloat(' ' + number).toFixed(2);
    else return parseFloat(' ' + number).toFixed(fix);
}
Vue.filter('moneyFormatWithDotNoMoreThan', moneyFormatWithDotNoMoreThan);

// 金额保留两位小数(退一取整)
function formatMoneyFloorWithTwoDot(money, lessThanZero) {
    if (!money || money == 0) return '0.00';
    if (!lessThanZero && Number(money) < 0) return '0.00';// 默认不允许小于0
    var number = parseFloat(' ' + money)
    var arr = number.toString().split('.')
    if (arr.length == 1) return number.toString() + ".00"
    if (arr.length > 1) {
        if (arr[1].length == 1) {
            return number.toString() + "0"
        } else {
            return parseFloat(arr[0] +'.'+ arr[1].substring(0, 2)).toFixed(2)
        }
    }
}
Vue.filter('formatMoneyFloorWithTwoDot', formatMoneyFloorWithTwoDot);

function formatMoneyFloor(money, lessThanZero) {
    switch (i18n.locale) {
        default:
        case 'zhHans':
            return formatMoneyFloorWithTwoDot(money, lessThanZero);
    }
}
Vue.filter('formatMoneyFloor', formatMoneyFloor);

// 金额转文字大写格式
function digitUppercase(price) {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = price < 0 ? '欠' : '';
    price = Math.abs(price);
    var s = '';
    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(price * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    price = Math.floor(price);
    for (let i = 0; i < unit[0].length && price > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && price > 0; j++) {
            p = digit[price % 10] + unit[1][j] + p;
            price = Math.floor(price / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
}
Vue.filter('digitUppercase', digitUppercase);

export default {
    formatMoney,
    formatWithMoney,
    formatWithDot,
    formatWithDotNoMoreThan,
    moneyFormatWithDotNoMoreThan,
    formatTwoDot,
    formatNoDot,
    onlyInt,
    digitUppercase,
    formatMoneyFloorWithTwoDot,
    formatMoneyFloor
}